import { ServerOptions } from 'commons/types'
import { Request } from 'commons/utils/request'

export const remove = (opts: ServerOptions) => Request.delete(Request.urls.bank.bsaBatch, opts)

export const uploadBatchFile = (formData: any) => Request.post(Request.urls.bank.bsaCtrUploadBatchFile, formData)
